import { c as _c } from "react/compiler-runtime";
import '@/styles/globals.css';
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import Head from 'next/head';
import { GraphQLProvider } from '@/lib/apollo';
import ApplicationInsights, { setAuthenticatedUser } from '@/lib/applicationinsights';
import { AppProps } from 'next/app';
import { ThemeProvider } from '@mui/material/styles';
import theme from '@/layout/theme';
import MainLayout, { UnauthorizedLayout } from '@/layout';
import { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import Login from '@/components/Login';
import { ContentError, ContentLoader } from '@/layout/ContentLoading';
import '@/lib/i18n';
import { CssBaseline } from '@mui/material';
import ForceLogout from '@/components/ForceLogout';
import { useIsHydrated } from '@/hooks/useIsHydrated';
function StyraApp(props) {
  const $ = _c(9);
  const {
    Component,
    pageProps
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CssBaseline />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Head><title>Stýra</title><link rel="icon" href="/favicon.ico" /></Head>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      redirect_uri: typeof window !== "undefined" ? window.location.origin + "/callback" : undefined,
      audience: "hasura"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== Component || $[4] !== pageProps) {
    t3 = <GraphQLProvider><AppInitializer Component={Component} pageProps={pageProps} /></GraphQLProvider>;
    $[3] = Component;
    $[4] = pageProps;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ForceLogout />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <ThemeProvider theme={theme}>{t0}<ApplicationInsights>{t1}<Auth0Provider domain={process.env.NEXT_PUBLIC_AUTH0_DOMAIN || ""} clientId={process.env.NEXT_PUBLIC_AUTH0_CLIENTID || ""} authorizationParams={t2} useRefreshTokens={true} cacheLocation="localstorage">{t3}{t4}</Auth0Provider></ApplicationInsights></ThemeProvider>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
export default StyraApp;
const AppInitializer = t0 => {
  const $ = _c(8);
  const {
    Component,
    pageProps
  } = t0;
  const {
    user,
    isLoading,
    isAuthenticated
  } = useAuth0();
  const {
    ready,
    i18n
  } = useTranslation();
  const translationError = i18n.failedLoading;
  const isHydrated = useIsHydrated();
  let t1;
  if ($[0] !== translationError) {
    t1 = () => translationError ? <ContentError title="Service Unavailable" message="We're currently experiencing connection issues. Please try refreshing the page in a few minutes or contact support." /> : <ContentLoader message="" />;
    $[0] = translationError;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const renderUnauthorizedContent = t1;
  if (!isHydrated) {
    return null;
  }
  if (!isAuthenticated && !isLoading) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Login />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (translationError || !ready || isLoading) {
    let t2;
    if ($[3] !== renderUnauthorizedContent) {
      t2 = <UnauthorizedLayout>{renderUnauthorizedContent()}</UnauthorizedLayout>;
      $[3] = renderUnauthorizedContent;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  setAuthenticatedUser(user["https://hasura.io/jwt/claims"]?.["x-hasura-ta-user-id"] || "no ta-user-id in auth0 authorisation");
  let t2;
  if ($[5] !== Component || $[6] !== pageProps) {
    t2 = <MainLayout Component={Component} pageProps={pageProps} />;
    $[5] = Component;
    $[6] = pageProps;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};